export const THEME = {
    light: 'light-theme',
    dark: 'dark-theme'
};
